export default function convertOptions (options) {
  const parsed = {}
  if (!Array.isArray(options)) {
    options = [options]
  }
  options.filter(x => /-/g.test(x)).forEach((element) => {
    const elements = element.split('-')

    if (Array.isArray(elements) && elements.length >= 2) {
      const filter = Number(elements[0])
      const option = Number(elements[1])

      if (parsed[filter]) {
        parsed[filter].push(option)
      } else {
        parsed[filter] = [option]
      }
    }
  })
  return parsed
}
